module.exports = __webpack_public_path__ + "img/itx-file-type-unknown.43cf0705.svg";